
    <span class="status-circle"
          [ngClass]="{
            'status-circle--green': rssFeed.enabled,
            'status-circle--red': !rssFeed.enabled
          }">
      <i class="fas fa-circle"></i>
    </span>
    <span #ref [ngClass]="ref.children.length >0 ?'pl-2':''" class="ml-1">
      <ng-content></ng-content>
    </span>

  